import { ImageUploadState } from "../types";


export const initialState: ImageUploadState = {
  formData: [],
  loading: false,
  pageNo: 1,
  pageSize: 30,
  totalRow: 0
};
